import { render, staticRenderFns } from "./deletesmsmessage.vue?vue&type=template&id=cc0f6498&"
import script from "./deletesmsmessage.vue?vue&type=script&lang=ts&"
export * from "./deletesmsmessage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "deletesmsmessage.vue"
export default component.exports